import Color from 'color';
import { Localization } from 'static/localization/localization';

export const useStyles = () => {
    const BASIC_STYLES: {
        key: string;
        name: string;
        img: string;
        url: string;
    }[] = [
        {
            key: 'Basic',
            name: Localization.CLASSIC,
            img: 'https://dvtqxks0zalev.cloudfront.net/app-static/style1.jpg',
            url: 'mapbox://styles/koudelka/cld4go9oi000k01p7wci751am'
        },
        {
            key: 'Satellite',
            name: Localization.SATELLITE,
            img: 'https://dvtqxks0zalev.cloudfront.net/app-static/style2.jpg',
            url: 'mapbox://styles/koudelka/ckstetxyy07gr17o4rh01vb9b'
        },
        {
            key: 'Outdoors',
            name: Localization.OUTDOORS,
            img: 'https://dvtqxks0zalev.cloudfront.net/app-static/style3.jpg',
            url: 'mapbox://styles/koudelka/ckwfq7e5k45h814o8521fnwo1'
        },
        {
            key: 'Dark',
            name: Localization.DARK,
            img: 'https://dvtqxks0zalev.cloudfront.net/app-static/style4.jpg',
            url: 'mapbox://styles/koudelka/cljg22h2800aa01quhsfbci1e'
        },
        {
            key: 'Light',
            name: Localization.LIGHT,
            img: 'https://dvtqxks0zalev.cloudfront.net/app-static/style5.jpg',
            url: 'mapbox://styles/koudelka/cljg23fbo003f01pcffds3h3f'
        }
    ];

    const COLOR_STYLES: {
        color: string;
        url: string;
    }[] = [
        {
            color: '#91BE0B',
            url: 'mapbox://styles/koudelka/cljg38q3p00ak01pe97dz8o6x'
        },
        {
            color: '#869000',
            url: 'mapbox://styles/koudelka/cljg3ln3k009q01pi759e88t5'
        },
        {
            color: '#528D02',
            url: 'mapbox://styles/koudelka/cljg3ln5a00am01pe3xeebfly'
        },
        {
            color: '#01580D',
            url: 'mapbox://styles/koudelka/cljg3ln8400an01pe6o5w294v'
        },
        {
            color: '#A1DEDE',
            url: 'mapbox://styles/koudelka/cljg3ln3g00b601pl8lzk52jw'
        },
        {
            color: '#68CEC7',
            url: 'mapbox://styles/koudelka/cljg3ln5j00ae01qu3k5i1f6a'
        },
        {
            color: '#24BCC4',
            url: 'mapbox://styles/koudelka/cljg3lnw2003o01pc6fokcmaa'
        },
        {
            color: '#ABCDE8',
            url: 'mapbox://styles/koudelka/cljg3mbr500af01quepndgb8y'
        },
        {
            color: '#88A5D4',
            url: 'mapbox://styles/koudelka/cljg3mbsf003h01r4ej1q7yuh'
        },
        {
            color: '#4675C2',
            url: 'mapbox://styles/koudelka/cljg3mc8j00ao01pe2o0m4rko'
        },
        {
            color: '#FCF9D3',
            url: 'mapbox://styles/koudelka/cljg3mc70009r01pi1k434h1j'
        },
        {
            color: '#FCE301',
            url: 'mapbox://styles/koudelka/cljg3mc2k00b701plgqoualzf'
        },
        {
            color: '#FABF04',
            url: 'mapbox://styles/koudelka/cljg3mc8k003i01r4348ucgug'
        },
        {
            color: '#DCA701',
            url: 'mapbox://styles/koudelka/cljg3mc8d00ag01qucx6b9zx8'
        },
        {
            color: '#F98A03',
            url: 'mapbox://styles/koudelka/cljg3mc5y00b801plfg2s2b6x'
        },
        {
            color: '#FA8676',
            url: 'mapbox://styles/koudelka/cljg3mcd900ah01qugudyaxnx'
        },
        {
            color: '#F1706E',
            url: 'mapbox://styles/koudelka/cljg3mc9600a801pah2pbe5y5'
        },
        {
            color: '#EA4548',
            url: 'mapbox://styles/koudelka/cljg3mcda00a901pacbmvb992'
        },
        {
            color: '#D5BA81',
            url: 'mapbox://styles/koudelka/cljg3md2n00b901pl6oze9sit'
        },
        {
            color: '#A6877F',
            url: 'mapbox://styles/koudelka/cljg3mnhc00ah01qs8luw6dk4'
        },
        {
            color: '#887965',
            url: 'mapbox://styles/koudelka/cljg3mnhe00ba01plc59g2wop'
        },
        {
            color: '#704F2B',
            url: 'mapbox://styles/koudelka/cljg3mnom00ac01qzbsys7d0l'
        },
        {
            color: '#F6A3C6',
            url: 'mapbox://styles/koudelka/cljg3xb31003p01pcfskbamsc'
        },
        {
            color: '#AD2F79',
            url: 'mapbox://styles/koudelka/cljg3x95200aq01pe9g624rj3'
        },
        {
            color: '#EFE6D7',
            url: 'mapbox://styles/koudelka/cljg3xd4800al01qscyztde5f'
        },
        {
            color: '#B2B2B2',
            url: 'mapbox://styles/koudelka/cljg3xer700ar01pe0f6eaxzg'
        },
        {
            color: '#666666',
            url: 'mapbox://styles/koudelka/cljg3xgr400aj01qu6kct3naj'
        },
        {
            color: '#000000',
            url: 'mapbox://styles/koudelka/cljg3xira00ak01qugxed44gm'
        }
    ];

    const isDarkMapStyle = (styleUrl: string) => {
        const basicStyle = BASIC_STYLES.find((e) => e.url === styleUrl);

        if (basicStyle && (basicStyle.key === 'Satellite' || basicStyle.key === 'Dark')) {
            return true;
        }

        const colorStyle = COLOR_STYLES.find((e) => e.url === styleUrl);

        if (colorStyle && Color(colorStyle.color).isDark()) {
            return true;
        }

        return false;
    };

    return { BASIC_STYLES, COLOR_STYLES, isDarkMapStyle };
};

export const BLANK_STYLE = 'mapbox://styles/koudelka/cld4qatdp001e01pglhbqhffx';
